"use client";

import React from "react";
import { Clock, ArrowRight, Sparkles } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const treatments = [{
  id: "conventional-loans",
  title: "Conventional Loans",
  description: "The gold standard of home financing. Flexible terms and competitive rates for borrowers with solid credit profiles looking for long-term stability.",
  duration: "Fixed/ARM",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686387/img/modern_residential_architecture.png",
  badge: "Most Popular"
}, {
  id: "fha-financing",
  title: "FHA Financing",
  description: "Government-backed solutions designed to make homeownership accessible. Ideal for first-time buyers with lower down payment requirements.",
  duration: "Low Down",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686387/img/family_home_exterior.png",
  badge: "Accessible"
}, {
  id: "va-mortgages",
  title: "VA Mortgages",
  description: "Exclusive benefits for those who served. Zero down payment options and no private mortgage insurance for veterans and active military members.",
  duration: "0% Down",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686387/img/patriotic_home_detail.png",
  badge: "Military"
}, {
  id: "jumbo-loans",
  title: "Jumbo Loans",
  description: "High-value financing for luxury properties that exceed standard conforming limits. Tailored structures for complex financial portfolios.",
  duration: "High Limit",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686387/img/luxury_glass_estate.png",
  badge: "Premium"
}];
export default function TailoredLoanPrograms() {
  return <section data-section-id="235277" id="tailored-loan-programs" className="bg-background py-24 sm:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-primary/5 rounded-lg blur-3xl pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 max-w-6xl relative z-10">
        <div className="text-center mb-16 md:mb-24">
          <h2 className="text-3xl md:text-5xl font-default font-bold tracking-tight text-foreground mb-6">
            Tailored Loan Programs
          </h2>
          <p className="text-slate-text text-lg md:text-xl max-w-2xl mx-auto font-default leading-relaxed">
            Strategic mortgage solutions engineered for your financial growth. We combine market expertise with a commitment to your long-term security.
          </p>
        </div>

        <Tabs defaultValue={treatments[0].id} className="w-full flex flex-col items-center">
          <TabsList className="mb-12 flex-wrap justify-center h-auto p-1.5 bg-muted/50 backdrop-blur-sm rounded-md border border-border/50">
            {treatments.map((treatment, index) => <TabsTrigger key={treatment.id} value={treatment.id} data-index={index} className="text-sm md:text-base px-6 py-3 rounded-md data-[state=active]:bg-primary data-[state=active]:shadow-md data-[state=active]:text-primary-foreground transition-all duration-300 font-default font-medium">
                {treatment.title}
              </TabsTrigger>)}
          </TabsList>

          <div className="w-full max-w-5xl">
            {treatments.map((treatment, index) => <TabsContent key={treatment.id} value={treatment.id} data-index={index} className="mt-0 focus-visible:outline-none focus-visible:ring-0">
                <div className="bg-card rounded-md overflow-hidden shadow-xl shadow-shadow-color/10 border border-border/50 flex flex-col md:flex-row">
                  
                  {}
                  <div className="relative w-full md:w-1/2 aspect-[4/3] md:aspect-auto md:min-h-[400px] overflow-hidden bg-muted">
                    <img src={treatment.image} alt={treatment.title} className="object-cover w-full h-full transition-transform duration-1000 hover:scale-105 desaturate-[0.2]" />
                    <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-transparent pointer-events-none" />
                    <div className="absolute top-6 left-6">
                      <Badge variant="secondary" className="bg-background/90 backdrop-blur-md text-primary border-none shadow-sm px-3 py-1.5 font-mono text-xs uppercase tracking-wider">
                        <Sparkles className="w-3.5 h-3.5 mr-1.5 text-secondary" />
                        {treatment.badge}
                      </Badge>
                    </div>
                  </div>

                  {}
                  <div className="w-full md:w-1/2 p-8 md:p-12 flex flex-col justify-center bg-card">
                    <div className="flex items-center gap-2 text-secondary mb-6">
                      <Clock className="w-4 h-4" />
                      <span className="text-xs font-mono font-medium tracking-widest uppercase">{treatment.duration}</span>
                    </div>
                    
                    <h3 className="text-2xl md:text-3xl font-default font-bold text-foreground mb-4">
                      {treatment.title}
                    </h3>
                    
                    <p className="text-slate-text text-base md:text-lg mb-8 leading-relaxed font-default">
                      {treatment.description}
                    </p>
                    
                    <div className="mt-auto pt-4">
                      <Button asChild size="lg" className="w-full sm:w-auto group rounded-md px-8 bg-primary hover:bg-primary/90 text-primary-foreground transition-all duration-300">
                        <Link to="/ContactPage">
                          Consult an Advisor
                          <ArrowRight className="w-4 h-4 ml-2 transition-transform duration-300 group-hover:translate-x-1" />
                        </Link>
                      </Button>
                    </div>
                  </div>

                </div>
              </TabsContent>)}
          </div>
        </Tabs>
      </div>
    </section>;
}